<script>
import Multiselect from "vue-multiselect";
import RadioBox from "@/components/radio-box";

import {
  required,
  maxValue,
} from "vuelidate/lib/validators";

export default {
  components: {
    Multiselect,
    RadioBox
  },
  props: {
    printDetail: {
      type: Object
    },
    masthead: {
      type: Object
    },
    package: {
      type: Object,
      required: false
    },
  },
  validations() {
    return {
      form: {
        earlyGeneralNews: { required },
        printSize: { required },
        printPrice: { required },
        insertionsPerWeek: { 
          required, 
          maxValue: maxValue(this.masthead.printDays.length)
        }
      }
    }
  },
  mounted () {
    if (this.printDetail) {
      Object.assign(this.form, this.printDetail)
    } 
  },
  data() {
    return {
      submitted: false,
      printSizeOptions: [
        'T22',
        'T24',
        'T42',
        'T44',
        'T84',
      ],
      earlyGeneralNewsOptions: [
        'EGN'
      ],
      form: {
        earlyGeneralNews: '',
        printPrice: '',
        printSize: '',
        insertionsPerWeek: '',
      }
    }
  },
  methods: {
    isPrintSizeAvailable(printSize) {
      return this.masthead ? this.masthead.printSizes.find((e) => e === printSize) : null;
    },
    submitPrintModal(cancel) {
      this.submitted = true;

      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.$emit('submit', { data: this.form, cancel })
      }
    },
  }
}
</script>

<template>
  <b-modal id="print-modal" centered size="lg">
    <template v-slot:modal-header="{ close }">
      <div class="text-center w-100 position-relative">
        <b-button size="sm" variant="link" @click="close()" class="position-absolute top-0 right-0">
          <i class="bx bx-x font-size-24 text-dark"></i>
        </b-button>
        <div class="text-center">
          <h4>Print Channel</h4>
          <p class="mb-0">Select inventory for Print Configuration</p>
        </div>
      </div>
    </template>
    <div>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Sections to choose" label-for="earlyGeneralNews">
            <multiselect
              :class="{ 'is-invalid': submitted && $v.form.earlyGeneralNews.$error }"
              :options="earlyGeneralNewsOptions"
              deselect-label=""
              placeholder="Select Section"
              select-label=""
              v-model="form.earlyGeneralNews"
            ></multiselect>
            <div v-if="submitted && $v.form.earlyGeneralNews.$error" class="invalid-feedback">
              <span v-if="!$v.form.earlyGeneralNews.required">This value is required.</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <b-form-group>
        <label for="size" class="card-title">Size</label>
        <div class="row" :class="{ 'is-invalid': submitted && $v.form.printSize.$error }">
          <div class="col" v-for="printSize in printSizeOptions" :key="printSize">
            <radio-box
              :title="printSize"
              icon="bx-fullscreen"
              :id="printSize"
              :value="printSize"
              name="printSize"
              v-model="form.printSize"
              :disabled="!isPrintSizeAvailable(printSize)"
            />
          </div>
        </div>
        <div v-if="submitted && $v.form.printSize.$error" class="invalid-feedback">
          <span v-if="!$v.form.printSize.required">This value is required.</span>
        </div>
      </b-form-group>
      <div class="row">
        <div class="col-12 col-md-4">
          <b-form-group label="Booking Deadline" label-for="daysOutToBooking">
            <b-form-input placeholder="no. of days prior to Creative" id="daysOutToBooking" name="daysOutToBooking" type="number" :value="masthead ? masthead.bookingDeadline : null" disabled  />
          </b-form-group>
        </div>
        
        <div class="col-12 col-md-4">
          <b-form-group label="Creative Deadline" label-for="daysOutToProduction">
            <b-form-input placeholder="No. of days" id="daysOutToProduction" name="daysOutToProduction" type="number" :value="masthead ? masthead.printDeadline : null" disabled  />
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group label="Print Cost ex GST" label-for="printPrice">
            <b-form-input id="printPrice" name="printPrice" type="text" v-model="form.printPrice" placeholder="Enter total print cost" :class="{ 'is-invalid': submitted && $v.form.printPrice.$error }" />
            <div v-if="submitted && $v.form.printPrice.$error" class="invalid-feedback">
              <span v-if="!$v.form.printPrice.required">This value is required.</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group label="Average readership" label-for="readership">
            <b-form-input id="readership" name="readership" type="text" :value="masthead ? masthead.averageReadership : null | formatNumberWithCommas" disabled />
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group label="Total Impacts" label-for="impacts">
            <b-form-input id="impacts" name="impacts" type="text" disabled :value="this.masthead && this.package.type === 'Print & digital' ? this.masthead.impactsPerInsertion * this.package.weeksDuration * this.package.insertionsPerWeek : null | formatNumberWithCommas"  />
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group label="Insertions per week" label-for="insertionsPerWeek">
            <b-form-input id="insertionsPerWeek" name="insertionsPerWeek" type="text" v-model="form.insertionsPerWeek" placeholder="Enter insertions per week" :class="{ 'is-invalid': submitted && $v.form.insertionsPerWeek.$error }" />
            <div v-if="submitted && $v.form.insertionsPerWeek.$error" class="invalid-feedback">
              <span v-if="!$v.form.insertionsPerWeek.required">This value is required.</span>
              <span v-if="!$v.form.insertionsPerWeek.maxValue">This value can't be higher than masthead print days.</span>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ cancel }">
      <div>
        <b-button 
          variant="primary" 
          @click="() => submitPrintModal(cancel)"
        >
          Save and Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>